<template >
  <base-dialog-form :type="type" ref="editAffiliazioniDialog" :title="$t('view_affiliations')+' '+code" color="secondary"
    icon="mdi-file-document-outline">
    <v-container>
      <v-row v-if="method !== 'ENTE' && mode == 'MyASD' && !activeAffiliation">
        <affiliazione-MYASD></affiliazione-MYASD>
      </v-row>
      <v-row v-if="method !== 'ENTE' && mode == 'LIBERTAS' && !activeAffiliation">
        <affiliazione-LIBERTAS @isUpdated="emitUpload"></affiliazione-LIBERTAS>
      </v-row>
      <v-row>
        <v-col cols="12">
          <data-tables @sendToLibertas="sendToLibertas" :headers="headers" :table-data="tableData" />
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import affiliazioneMYASD from "@/app/ente/affiliazioneMYASD.vue";
import affiliazioneLIBERTAS from "@/app/ente/affiliazioneLIBERTAS.vue";
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "edit-affiliazioni",
  props: {
    parmsMethod: null,
    parmsAsdCode: null,
    parmsMode: null,
    type: {
      type: String, // not 'string'
      required: false,
      default: "dialog",
    },
  },
  components: {
    MyDatepicker,
    DataTables,
    affiliazioneMYASD,
    affiliazioneLIBERTAS,
  },
  computed: {
    computedRequired: function () {
      let _ = this;
      if (_.docRequired && _.docRequired.length > 0 && _.tableData && _.tableData.length > 0) {
        let docRequired = []
        for (let required of _.docRequired) {
          let presente = _.tableData.find(el => {
            return el.type === required && el.dateInz <= new Date() && el.dateEnd >= new Date()
          })
          if (!presente) docRequired.push(required)
        }
        if (docRequired.length > 0) return _.$t("missing_document") + ": " + docRequired.join(", ")
      }
      else return null;
    },
  },
  data() {
    return {
      method: null,
      code: null,
      mode: null,
      headers: [],
      tableData: [],
      activeAffiliation: false,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    emitUpload(item) {
      this.loadData();
    },
    open(method, code) {
      this.method = method;
      this.code = code;
      this.loadData();
      this.$refs.editAffiliazioniDialog.open();
    },
    sendToLibertas(item){
      let _ = this;
      if (item ) {
          _.chiamataAxios("POST", "/auth/ente/sendAffiliation2LIBERTAS/" + item.custId+"/"+item.anno, {
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadTable();
            }
          });
        }
    },
    loadData() {
      let _ = this;
      let code = systemData.ASD.code;
      _.ifEnte = false;
      _.headers = [
        { text: this.$t("ente"), value: "ente" },
        { text: this.$t("season"), value: "anno" },
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("discipline"), value: "discipline" },
        { text: this.$t("active"), value: "active_icon", type: "icons" },
      ];
      if(_.method == "ENTE"){
        _.ifEnte = true;
        _.headers = [
        { text: this.$t("ente"), value: "ente" },
        { text: this.$t("asd_name"), value: "nome" },
        { text: this.$t("season"), value: "anno" },
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("discipline"), value: "discipline" },
        { text: this.$t("active"), value: "active_icon", type: "icons" },
        { text: this.$t("order"), value: "orderId"},
        { text: this.$t("affiliation_code"), value: "affiliationCode"},
        { text: this.$t("options"), value: "options", type: "buttons" },
      ];
      }
      if (_.code) code = _.code;
      
      _.tableData = [];
      _.activeAffiliation = false;
      _.mode = "";
      _.chiamataAxios("GET", "/auth/ente/listAsdAffiliazioni/" + code+"?mode="+this.method).then(
        (response) => { 
          _.activeAffiliation = response.data.active;
          _.mode = response.data.mode;
          _.tableData = response.data.affiliazioni.map(function (item) {
            if (item.attiva) item.active_icon = [{ icon: "mdi-check", color: "green" }];
            else item.active_icon = [];
            item.discipline =  item.discipline.map(el => {return el.descr}).join(", ")
            if(_.method == "ENTE" && item.sendToLibertas){
              item.options = [ {
                icon: "mdi-upload",
                color: "success",
                text: _.$t("send_to_libertas"),
                function: "sendToLibertas",
              }]
            }
            return item;
          });
        }
      );
    },
  },
  created() { },
  mounted() {
    if (this.parmsAsdCode) this.code = this.parmsAsdCode;
    if (this.parmsMethod) this.method = this.parmsMethod;
    if (this.parmsMode) this.mode = this.parmsMode;
    this.loadData();
  },
  watch: {
    parmsAsdCode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.code = newVal;
    },
    parmsMethod: function (newVal, oldVal) {
      // watch it
      if (newVal) this.method = newVal;
    },
    parmsMode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.mode = newVal;
    },
    code: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>